'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dResult from "./presto.-Audit-View$-Audit-Result.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$AuditResult$() {
}
export { $c_Lpresto_AuditView$AuditResult$ as $c_Lpresto_AuditView$AuditResult$ };
$p = $c_Lpresto_AuditView$AuditResult$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$AuditResult$;
/** @constructor */
function $h_Lpresto_AuditView$AuditResult$() {
}
export { $h_Lpresto_AuditView$AuditResult$ as $h_Lpresto_AuditView$AuditResult$ };
$h_Lpresto_AuditView$AuditResult$.prototype = $p;
$p.l = (function() {
  return "AuditResult";
});
$p.cGX = (function(x$0) {
  return new $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dResult.$c_Lpresto_AuditView$AuditResult(x$0.j(0), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(1)), (x$0.j(2) | 0), (x$0.j(3) | 0), x$0.j(4), x$0.j(5));
});
var $d_Lpresto_AuditView$AuditResult$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$AuditResult$, "presto.AuditView$AuditResult$", ({
  EO: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AuditView$AuditResult$ as $d_Lpresto_AuditView$AuditResult$ };
var $n_Lpresto_AuditView$AuditResult$;
function $m_Lpresto_AuditView$AuditResult$() {
  if ((!$n_Lpresto_AuditView$AuditResult$)) {
    $n_Lpresto_AuditView$AuditResult$ = new $c_Lpresto_AuditView$AuditResult$();
  }
  return $n_Lpresto_AuditView$AuditResult$;
}
export { $m_Lpresto_AuditView$AuditResult$ as $m_Lpresto_AuditView$AuditResult$ };
//# sourceMappingURL=presto.-Audit-View$-Audit-Result$.js.map
